// IE don't implement window.scrollX
if(!("scrollX" in window)){
	Object.defineProperty(window, "scrollX", {
		get: function(){
			return window.pageXOffset;
		},
		set: function(value){
			window.pageXOffset = value;
		}
	});
}